module.exports = __webpack_public_path__ + "static/img/cont61_02.60316e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont61_02.jpg
// module id = w5Zp
// module chunks = 0